import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Main from './component/main/Main';
import NavFoot from './component/main/NavFoot';
import AboutUs from './component/Pages/AboutUs';
import Service from './component/Pages/Service';
import ContactUs from './component/Pages/ContactUs';
import LegalOpinion from './component/Pages/LegalOpinion';
import PropertyReg from './component/Pages/PropertyReg';
import Estamp from './component/Pages/Estamp';
import MarrageReg from './component/Pages/MarrageReg';
import Pancard from './component/Pages/Pancard';
import Certification from './component/Pages/Certification';
import Katha from './component/Pages/Katha';
import Gst from './component/Pages/Gst';
import Tds from './component/Pages/Tds';
import Mainfol from './Admin/Mainfol';
import LLPName from './component/Pages/LLPName';
import Ec from './component/Pages/Ec';
import Pvt from './component/Pages/Pvt';
import ScrollToTop from './ScrollToTop';
import ExpertAdviceForm from './component/Pages/ExpertAdvice';
import JoinTeam from './component/main/JoinTeam';
import LegalService from './component/Pages/LegalService';
 

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop/>
    <Routes>
      <Route path="/" element={<NavFoot/>}>
      <Route index element={<Main/>}/>
      <Route path="about"element={<AboutUs/>}/>
      <Route path="services"element={<Service/>}/>
      <Route path="contact-us"element={<ContactUs/>}/>
      <Route path="legal-opinion"element={<LegalOpinion/>}/>
      <Route path="property-register"element={<PropertyReg/>}/>
      <Route path="e-stamp"element={<Estamp/>}/>
      <Route path="marriage-registration"element={<MarrageReg/>}/>
      <Route path="pancard"element={<Pancard/>}/>
      <Route path="revenue-documents"element={<Certification/>}/>
      <Route path="katha-tax-transfer"element={<Katha/>}/>
      <Route path="gst"element={<Gst/>}/>
      <Route path="itrs-tds"element={<Tds/>}/>
      <Route path="llp-registration"element={<LLPName/>}/>
      <Route path="ec-certified-copies"element={<Ec/>}/>
      <Route path="private-ltd-registration"element={<Pvt/>}/>
      <Route path="export-advice"element={<ExpertAdviceForm/>}/>
      <Route path="join-team"element={<JoinTeam/>}/>
      <Route path="legal-service"element={<LegalService/>}/>






      <Route path="admin"element={<Mainfol/>}/>












    
    
    
      
      </Route>
      </Routes>
    
    </BrowserRouter>
  );
}

export default App;
